import * as $ from 'jquery';
import { Cart } from './Models/Cart';

export class SummarySection {
    public invoiceReference: JQuery;
    public comment: JQuery;
    private readonly apiUrl: string;
    private cart: JQuery;
    private cartEmpty: JQuery;
    private wizardNext: JQuery;
    private tooManyTickets: JQuery;
    private pickEmployees: JQuery;
    private maxAmountPurchaseableTickets: number;
    private lastUpdateUrl: string;
    private shouldHideZoneSelectionCallback: (productTypeId: string) => any;

    constructor(private container: JQuery,
                apiUrl: string,
                maxAmountPurchaseableTickets: number,
                shouldHideZoneSelection: (productTypeId: string) => any) {
        this.apiUrl = apiUrl;
        this.cart = container.find('.cart-summary');
        this.cartEmpty = container.find('.cart-summary-empty');
        this.invoiceReference = container.find('#InvoiceReference');
        this.comment = container.find('#Comment');
        this.wizardNext = container.find('.wizard-next');
        this.pickEmployees = container.find('.picked-ticket-type-next');
        this.tooManyTickets = container.find('.too-many-tickets-message');
        this.maxAmountPurchaseableTickets = maxAmountPurchaseableTickets;
        this.shouldHideZoneSelectionCallback = shouldHideZoneSelection;
        this.tooManyTickets.hide();
    }

    public updateSummary(currentCart: Cart): void {
        let validTicketAmount = true;

        if (currentCart.recipients && currentCart.recipients.length > 0) {
            let i;
            for (i = 0; i < currentCart.recipients.length; i = i + 1) {
                let recipient = currentCart.recipients[i];
                if (recipient.count > currentCart.productTypeTicketMaxCount) {
                    validTicketAmount = false;
                }
            }
        }

        let ticketCount = currentCart.recipients.reduce(function (tot, recipient) {
            return tot + recipient.count;
        }, 0);
        const section = this;

        // Check if organization order and count
        if(currentCart.organizationDepartmentEmployeeCount) {
            ticketCount += currentCart.organizationDepartmentEmployeeCount;    
        }

        let isValid = true;

        if (ticketCount > this.maxAmountPurchaseableTickets || !validTicketAmount) {
            this.wizardNext.prop('disabled', true);
            const tooManyTicketsText = $('#max-ticket-count');
            tooManyTicketsText.text(tooManyTicketsText.text().replace('{0}', currentCart.productTypeTicketMaxCount.toString()));
            this.tooManyTickets.show();
            isValid = false;
        } else {
            this.tooManyTickets.hide();
        }

        if (!isValid) {
            this.cart.hide();
            return;
        }

        this.cart.show();

        if (ticketCount > 0 && this.validateSummaryFields(currentCart)) {
            this.wizardNext.prop('disabled', false);

            let url = this.apiUrl +
                '?zoneType=' +
                currentCart.zoneType +
                '&zoneFrom=' +
                (currentCart.zoneFrom ? currentCart.zoneFrom : '') +
                '&zoneTo=' +
                (currentCart.zoneTo ? currentCart.zoneTo : '') +
                '&productTypeId=' +
                currentCart.productTypeId +
                '&productId=' +
                currentCart.productId +
                '&ticketCount=' + ticketCount;

            if (url !== this.lastUpdateUrl) {
                this.lastUpdateUrl = url;
                $.ajax({
                    url: url,
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        $('.product').text(data.productTypeName);
                        $('.ticket-count').text(data.ticketCount);
                        $('.ticket-total').text(data.totalPriceIncTaxFormatted);
                        let zoneText = data.zoneFrom;
                        if (currentCart.zoneTo) {
                            zoneText += ' - ' + data.zoneTo;
                        }

                        if (section.shouldHideZoneSelectionCallback(currentCart.productTypeId)) {
                            zoneText = '';
                        }

                        $('.zones').text(zoneText);
                        $('.ticket-price').text(data.singlePriceIncTaxFormatted);
                        $('.ticket-price-vat').text(data.totalTaxFormatted);
                        $('.recipients-count').text(currentCart.recipients.length);
                        if(currentCart.recipients.length<=0) {
                            $('.cart-summary-recipients').hide();
                            $('.show-recipients').hide();
                        }
                        section.cartEmpty.hide();
                        section.cart.show();

                        var recipientArea = $('.recipient-hidden-area');
                        recipientArea.empty();
                        var table = '<table class="table table-borderless table-striped"><tbody>';
                        currentCart.recipients.forEach(recipient => {
                            table += '<tr><td>' + recipient.name + '</td><td>' + (recipient.countryCode ?? '') + ' ' + recipient.phoneNumber + '</td></tr>';
                        });
                        table += '</tbody></table>';
                        recipientArea.append(table);
                    }
                });
            }
        } else {
            this.cartEmpty.show();
            this.cart.hide();
            this.wizardNext.prop('disabled', true);
        }
    }

    public updateTicket(currentCart: Cart): void {
        // to ensure that this is always empty when in ticket-area
        currentCart.recipients = [];

        $('.ticket-type').text($('#SelectedProductTypeId option:selected').text());
        $('.ticket-recipient-type').text($('#SelectedProductId option:selected').text());
        $('.ticket-zone-from').text($('#SelectedFromZone option:selected').text());
        $('.ticket-zone-to').text($('#SelectedToZone option:selected').text());

        // this should enuse that button is only active if everything is okay
        if (this.validateSummaryFields(currentCart)) {
            this.pickEmployees.prop('disabled', false);
        } else {
            this.pickEmployees.prop('disabled', true);
        }
    }

    public validateSummaryFields(currentCart: Cart): boolean {
        if (this.shouldHideZoneSelectionCallback(currentCart.productTypeId)) {
            return (this.isNonEmptyString(currentCart.productId) && this.isNonEmptyString(currentCart.productTypeId));
        } else {
            return (this.isNonEmptyString(currentCart.productId) &&
                this.isNonEmptyString(currentCart.productTypeId) &&
                this.isNonEmptyString(currentCart.zoneFrom));
        }
    }

    public isNonEmptyString(str: string): boolean {
        return str && str.length > 0;
    }
}
